import Permissoes from "@/utils/permissoes";

import { formMode } from "@/utils/form.helpers";

const routes = [
  {
    path: "/cadastros/clientes",
    name: "clientes",
    component: () => import("@/views/cadastros/clientes/index.vue"),
    meta: {
      title: 'Clientes',
      authRequired: true,
      permissoes: [Permissoes.VisualizarClientes],
      menus: [Permissoes.ModuloCadastros, Permissoes.Clientes]
    },
  },
  {
    path: "/cadastros/clientes/visualizar/:id",
    name: "clientes-visualizar",
    component: () => import("@/views/cadastros/clientes/form.vue"),
    meta: {
      title: 'Clientes',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarClientes],
      menus: [Permissoes.ModuloCadastros, Permissoes.Clientes]
    },
  },
  {
    path: "/cadastros/clientes/editar/:id",
    name: "clientes-editar",
    component: () => import("@/views/cadastros/clientes/form.vue"),
    meta: {
      title: 'Clientes',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarClientes],
      menus: [Permissoes.ModuloCadastros, Permissoes.Clientes]
    },
  },
  {
    path: "/cadastros/clientes/cadastrar",
    name: "clientes-cadastrar",
    component: () => import("@/views/cadastros/clientes/form.vue"),
    meta: {
      title: 'Clientes',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarClientes],
      menus: [Permissoes.ModuloCadastros, Permissoes.Clientes]
    },
  },

  {
    path: "/cadastros/veiculos",
    name: "veiculos",
    component: () => import("@/views/cadastros/veiculos/index.vue"),
    meta: {
      title: 'Veículos',
      authRequired: true,
      permissoes: [Permissoes.VisualizarVeiculos],
      menus: [Permissoes.ModuloCadastros, Permissoes.Veiculos]
    },
  },
  {
    path: "/cadastros/veiculos/visualizar/:id",
    name: "veiculos-visualizar",
    component: () => import("@/views/cadastros/veiculos/form.vue"),
    meta: {
      title: 'Veículos',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarVeiculos],
      menus: [Permissoes.ModuloCadastros, Permissoes.Veiculos]
    },
  },
  {
    path: "/cadastros/veiculos/editar/:id",
    name: "veiculos-editar",
    component: () => import("@/views/cadastros/veiculos/form.vue"),
    meta: {
      title: 'Veículos',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarVeiculos],
      menus: [Permissoes.ModuloCadastros, Permissoes.Veiculos]
    },
  },
  {
    path: "/cadastros/veiculos/cadastrar",
    name: "veiculos-cadastrar",
    component: () => import("@/views/cadastros/veiculos/form.vue"),
    meta: {
      title: 'Veículos',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarVeiculos],
      menus: [Permissoes.ModuloCadastros, Permissoes.Veiculos]
    },
  },

  {
    path: "/cadastros/cacambas",
    name: "cacambas",
    component: () => import("@/views/cadastros/cacambas/index.vue"),
    meta: {
      title: 'Caçambas',
      authRequired: true,
      permissoes: [Permissoes.VisualizarCacambas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Cacambas]
    },
  },
  {
    path: "/cadastros/cacambas/visualizar/:id",
    name: "cacambas-visualizar",
    component: () => import("@/views/cadastros/cacambas/form.vue"),
    meta: {
      title: 'Caçambas',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarCacambas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Cacambas]
    },
  },
  {
    path: "/cadastros/cacambas/editar/:id",
    name: "cacambas-editar",
    component: () => import("@/views/cadastros/cacambas/form.vue"),
    meta: {
      title: 'Caçambas',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarCacambas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Cacambas]
    },
  },
  {
    path: "/cadastros/cacambas/cadastrar",
    name: "cacambas-cadastrar",
    component: () => import("@/views/cadastros/cacambas/form.vue"),
    meta: {
      title: 'Caçambas',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarCacambas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Cacambas]
    },
  },

  {
    path: "/cadastros/motoristas",
    name: "motoristas",
    component: () => import("@/views/cadastros/motoristas/index.vue"),
    meta: {
      title: 'Motoristas',
      authRequired: true,
      permissoes: [Permissoes.VisualizarMotoristas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Motoristas]
    },
  },
  {
    path: "/cadastros/motoristas/visualizar/:id",
    name: "motoristas-visualizar",
    component: () => import("@/views/cadastros/motoristas/form.vue"),
    meta: {
      title: 'Motoristas',
      authRequired: true,
      formMode: formMode.View,
      permissoes: [Permissoes.VisualizarMotoristas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Motoristas]
    },
  },
  {
    path: "/cadastros/motoristas/editar/:id",
    name: "motoristas-editar",
    component: () => import("@/views/cadastros/motoristas/form.vue"),
    meta: {
      title: 'Motoristas',
      authRequired: true,
      formMode: formMode.Edit,
      permissoes: [Permissoes.EditarMotoristas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Motoristas]
    },
  },
  {
    path: "/cadastros/motoristas/cadastrar",
    name: "motoristas-cadastrar",
    component: () => import("@/views/cadastros/motoristas/form.vue"),
    meta: {
      title: 'Motoristas',
      authRequired: true,
      formMode: formMode.Create,
      permissoes: [Permissoes.CriarMotoristas],
      menus: [Permissoes.ModuloCadastros, Permissoes.Motoristas]
    },
  },

];
export default routes;
